import { Box, Typography } from "@mui/material"
import { CustomeIconButton } from "../customeIconButton"
import { icons } from "../../utils/icons"
import { ScrollContainer } from "../scrollContainer"
import { useStyles } from "./styles"

export const NewListTooltipDetail = ({ list, isBold }: { list: string[], isBold?:boolean }) => {
    const styles = useStyles()
    return (
        <Box sx={styles.container}>
            <Typography variant="text_grey" fontWeight={!!isBold ? 'bold' : '500'} sx={{wordBreak: 'break-word' }}>{list[0]  || 'N/A'}</Typography>

            {list?.length > 1 && (
                <CustomeIconButton
                    iconButtonProps={{ disableRipple: true, sx: styles.icon }}
                    title={<ScrollContainer sx={styles.list}>{list.map((item, index) => <Typography key={index} variant="text_grey" color='white'>{item}</Typography>)}</ScrollContainer>}
                    icon={icons('more-tag')}
                />
            )}
        </Box>
    )
}